import { render } from "./SwapChainList.vue?vue&type=template&id=721d2ef4"
import script from "./SwapChainList.vue?vue&type=script&lang=js"
export * from "./SwapChainList.vue?vue&type=script&lang=js"

import "./SwapChainList.vue?vue&type=style&index=0&id=721d2ef4&lang=scss"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__